import { memo, useCallback, useState, forwardRef } from 'react';
import { Chip } from '@Sage/hoi-poi-ui';
import AdvancedSelect from 'components/AdvancedSelect';
import { getLiteral } from 'utils/getLiteral';
import './styles.scss';

const InsertFieldTool = forwardRef(({ insertFieldOptions, onChange, value }, ref) => {
    const [visible, setVisible] = useState(false);

    const innerOnChangeVisible = useCallback((visible) => {
        setVisible(visible);
    }, []);

    return (
        <AdvancedSelect
            ref={ref}
            filterPlaceholder={getLiteral('label_placeholder_entity')}
            searchPlaceholder={getLiteral('placeholder_search_field')}
            menuTitle={getLiteral('title_insert_fields')}
            placeholder={getLiteral('label_placeholder_field')}
            onChange={onChange}
            onChangeVisible={innerOnChangeVisible}
            options={insertFieldOptions?.options}
            defaultFilter={insertFieldOptions?.filterOptions?.[0]?.value}
            filterOptions={insertFieldOptions?.filterOptions}
            value={value}
            isFullWidth
            useMenuPortal={false}
        >
            <Chip onClick={() => {}} icon="variables" size="large" isUnfolded isActive={visible}>
                {getLiteral('title_insert_fields')}
            </Chip>
        </AdvancedSelect>
    );
});

InsertFieldTool.displayName = 'InsertFieldTool';

export default memo(InsertFieldTool);
